<form [formGroup]="form">
    <h2 *ngIf="asset?.Detail?.AssetName" mat-dialog-title>Asset Name : {{asset.Detail.AssetName}}</h2>
    <mat-dialog-content>
        <mat-form-field appearance="outline">
            <mat-label>Rank</mat-label>
            <input matInput type="number" formControlName="rank" min="1" max="9999999" required (input)="onRankInput($event)"/>

            <!-- Validation messages -->
            <div *ngIf="rankControl?.invalid && rankControl?.touched">
              <mat-error *ngIf="rankControl?.hasError('required')">Rank is required.</mat-error>
              <mat-error *ngIf="rankControl?.hasError('min')">Rank must be at least 1.</mat-error>
              <mat-error *ngIf="rankControl?.hasError('max')"> Rank must be less than 9999999</mat-error>
            </div>
        </mat-form-field>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <button mat-stroked-button type="button" (click)="closeDialog()">Cancel</button>
        <button mat-raised-button type="button" color="accent" [disabled]="form.invalid" (click)="save()">Save</button>
    </mat-dialog-actions>
</form>
